"use client";
import { useEffect, useState } from "react";
export function DashboardLiveView() {
  const [state, setState] = useState<{
    loading: boolean;
    error?: string;
    user?: { full_name: string };
    stats?: { clients: number; deals: number; revenue: string; open_tasks: number };
    activity: { action: string }[];
    tasks: { id: string; title: string; status: string; due_at?: string }[];
  }>({ loading: true, activity: [], tasks: [] });
  useEffect(() => {
    fetch("/api/dashboard")
      .then((r) => (r.ok ? r.json() : Promise.reject()))
      .then((data) => setState({ loading: false, ...data }))
      .catch(() =>
        setState({
          loading: false,
          error: "Не удалось загрузить данные ателье",
          activity: [],
          tasks: [],
        }),
      );
  }, []);
  if (state.loading)
    return (
      <section className="module-view" data-amazi-id={"crm/src/features/crm/dashboard-live-view.tsx:27:7"}>
        <div className="empty-message" data-amazi-id={"crm/src/features/crm/dashboard-live-view.tsx:28:9"}>Загружаем показатели ателье…</div>
      </section>
    );
  if (state.error)
    return (
      <section className="module-view" data-amazi-id={"crm/src/features/crm/dashboard-live-view.tsx:33:7"}>
        <div className="panel empty-route" data-amazi-id={"crm/src/features/crm/dashboard-live-view.tsx:34:9"}>
          <h2 data-amazi-id={"crm/src/features/crm/dashboard-live-view.tsx:35:11"}>Не удалось загрузить dashboard</h2>
          <p data-amazi-id={"crm/src/features/crm/dashboard-live-view.tsx:36:11"}>{state.error}</p>
        </div>
      </section>
    );
  const stats = state.stats ?? { clients: 0, deals: 0, revenue: "0", open_tasks: 0 };
  return (
    <section className="module-view" data-amazi-id={"crm/src/features/crm/dashboard-live-view.tsx:42:5"}>
      <div className="module-heading" data-amazi-id={"crm/src/features/crm/dashboard-live-view.tsx:43:7"}>
        <div data-amazi-id={"crm/src/features/crm/dashboard-live-view.tsx:44:9"}>
          <div className="breadcrumb" data-amazi-id={"crm/src/features/crm/dashboard-live-view.tsx:45:11"}>
            Рабочее пространство <span data-amazi-id={"crm/src/features/crm/dashboard-live-view.tsx:46:34"}>/</span> Обзор ателье
          </div>
          <h1 data-amazi-id={"crm/src/features/crm/dashboard-live-view.tsx:48:11"}>Добрый день, {state.user?.full_name ?? "коллега"}</h1>
          <p data-amazi-id={"crm/src/features/crm/dashboard-live-view.tsx:49:11"}>Заказы, сроки и загрузка мастеров на сегодня</p>
        </div>
      </div>
      <div className="stats-grid" data-amazi-id={"crm/src/features/crm/dashboard-live-view.tsx:52:7"}>
        <div className="stat-card" data-amazi-id={"crm/src/features/crm/dashboard-live-view.tsx:53:9"}>
          <div className="stat-top" data-amazi-id={"crm/src/features/crm/dashboard-live-view.tsx:54:11"}>
            <span data-amazi-id={"crm/src/features/crm/dashboard-live-view.tsx:55:13"}>Клиенты</span>
          </div>
          <div className="stat-value" data-amazi-id={"crm/src/features/crm/dashboard-live-view.tsx:57:11"}>{stats.clients}</div>
          <div className="stat-change" data-amazi-id={"crm/src/features/crm/dashboard-live-view.tsx:58:11"}>
            <em data-amazi-id={"crm/src/features/crm/dashboard-live-view.tsx:59:13"}>Постоянные клиенты</em>
          </div>
        </div>
        <div className="stat-card" data-amazi-id={"crm/src/features/crm/dashboard-live-view.tsx:62:9"}>
          <div className="stat-top" data-amazi-id={"crm/src/features/crm/dashboard-live-view.tsx:63:11"}>
            <span data-amazi-id={"crm/src/features/crm/dashboard-live-view.tsx:64:13"}>Заказы в работе</span>
          </div>
          <div className="stat-value" data-amazi-id={"crm/src/features/crm/dashboard-live-view.tsx:66:11"}>{stats.deals}</div>
          <div className="stat-change" data-amazi-id={"crm/src/features/crm/dashboard-live-view.tsx:67:11"}>
            <em data-amazi-id={"crm/src/features/crm/dashboard-live-view.tsx:68:13"}>Пошив и ремонт</em>
          </div>
        </div>
        <div className="stat-card" data-amazi-id={"crm/src/features/crm/dashboard-live-view.tsx:71:9"}>
          <div className="stat-top" data-amazi-id={"crm/src/features/crm/dashboard-live-view.tsx:72:11"}>
            <span data-amazi-id={"crm/src/features/crm/dashboard-live-view.tsx:73:13"}>Выручка</span>
          </div>
          <div className="stat-value" data-amazi-id={"crm/src/features/crm/dashboard-live-view.tsx:75:11"}>₽ {stats.revenue}</div>
          <div className="stat-change" data-amazi-id={"crm/src/features/crm/dashboard-live-view.tsx:76:11"}>
            <em data-amazi-id={"crm/src/features/crm/dashboard-live-view.tsx:77:13"}>Сумма заказов</em>
          </div>
        </div>
        <div className="stat-card" data-amazi-id={"crm/src/features/crm/dashboard-live-view.tsx:80:9"}>
          <div className="stat-top" data-amazi-id={"crm/src/features/crm/dashboard-live-view.tsx:81:11"}>
            <span data-amazi-id={"crm/src/features/crm/dashboard-live-view.tsx:82:13"}>Задачи мастеров</span>
          </div>
          <div className="stat-value" data-amazi-id={"crm/src/features/crm/dashboard-live-view.tsx:84:11"}>{stats.open_tasks}</div>
          <div className="stat-change" data-amazi-id={"crm/src/features/crm/dashboard-live-view.tsx:85:11"}>
            <em data-amazi-id={"crm/src/features/crm/dashboard-live-view.tsx:86:13"}>Требуют внимания</em>
          </div>
        </div>
      </div>
      <div className="panel activity-panel" data-amazi-id={"crm/src/features/crm/dashboard-live-view.tsx:90:7"}>
        <div className="panel-header" data-amazi-id={"crm/src/features/crm/dashboard-live-view.tsx:91:9"}>
          <div data-amazi-id={"crm/src/features/crm/dashboard-live-view.tsx:92:11"}>
            <h2 data-amazi-id={"crm/src/features/crm/dashboard-live-view.tsx:93:13"}>Последние изменения по заказам</h2>
            <p data-amazi-id={"crm/src/features/crm/dashboard-live-view.tsx:94:13"}>Примерки, сроки и рабочие уточнения</p>
          </div>
        </div>
        {state.activity.length === 0 ? (
          <div className="empty-message" data-amazi-id={"crm/src/features/crm/dashboard-live-view.tsx:98:11"}>Активности пока нет.</div>
        ) : (
          state.activity.map((item, index) => (
            <div className="activity-row" key={`${item.action}-${index}`} data-amazi-id={"crm/src/features/crm/dashboard-live-view.tsx:101:13"}>
              <strong data-amazi-id={"crm/src/features/crm/dashboard-live-view.tsx:102:15"}>{item.action}</strong>
            </div>
          ))
        )}
      </div>
      <div className="panel activity-panel dashboard-tasks" data-amazi-id={"crm/src/features/crm/dashboard-live-view.tsx:107:7"}>
        <div className="panel-header" data-amazi-id={"crm/src/features/crm/dashboard-live-view.tsx:108:9"}>
          <div data-amazi-id={"crm/src/features/crm/dashboard-live-view.tsx:109:11"}>
            <h2 data-amazi-id={"crm/src/features/crm/dashboard-live-view.tsx:110:13"}>Ближайшие события</h2>
            <p data-amazi-id={"crm/src/features/crm/dashboard-live-view.tsx:111:13"}>Открытые задачи и контрольные даты</p>
          </div>
        </div>
        {state.tasks.length === 0 ? (
          <div className="empty-message" data-amazi-id={"crm/src/features/crm/dashboard-live-view.tsx:115:11"}>Открытых задач нет.</div>
        ) : (
          state.tasks.map((task) => (
            <div className="task-row" key={task.id} data-amazi-id={"crm/src/features/crm/dashboard-live-view.tsx:118:13"}>
              <span className="task-copy" data-amazi-id={"crm/src/features/crm/dashboard-live-view.tsx:119:15"}>
                <strong data-amazi-id={"crm/src/features/crm/dashboard-live-view.tsx:120:17"}>{task.title}</strong>
                <span data-amazi-id={"crm/src/features/crm/dashboard-live-view.tsx:121:17"}>
                  {task.due_at ? new Date(task.due_at).toLocaleString("ru-RU") : "Без срока"}
                </span>
              </span>
              <span className="priority gray" data-amazi-id={"crm/src/features/crm/dashboard-live-view.tsx:125:15"}>{task.status}</span>
            </div>
          ))
        )}
      </div>
    </section>
  );
}
